import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class DrawsServiceService extends BaseService {
    apiGetDraws() {
       return this.post(API_URL + '/api/v2/draws', {
            account: store.state.account
        }).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.results;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new DrawsServiceService();
